export const environment = {
  production: false,
  baseUrl: 'https://stage.africa.cdn.retailer.management.pwa.farmrise.bayer.com',
  baseUrlUserService: 'https://stage.africa.cdn.retailer.management.pwa.farmrise.bayer.com/user_service'
};
